import ApiHttp from '../http';
import ModelArray from '../model/ModelArray'
import {Genre, Flag, Experience,FeaturedContent} from '../../model';

class MovieMetaService {

    /**
     * Service for interacting with the movies api
     */
    constructor() {
        this.meta = undefined;

    }

    _processExperiences(data) {
        return new ModelArray(data, Experience)
    }

    _processGenres(data) {
        return new ModelArray(data, Genre)
    }

    _processFlags(data) {
        return new ModelArray(data, Flag)
    }
    _processFeatured(data) {
        return new ModelArray(data, FeaturedContent)
    }

    _processMovieMeta(data) {
        return {
            genres: data.genres ? this._processGenres(data.genres.sort((a,b)=>a.Name < b.Name ? -1 : (a.Name > b.Name ? 1 : 0))) : [],
            experiences: data.experiences ? this._processExperiences(data.experiences.sort()) : [],
            flags: data.flags ? this._processFlags(data.flags.sort()) : [],
            featured_content:data.featured_content ? this._processFeatured(data.featured_content) : [],
            expired_movies: data.expired_movies
        }
    }

    setPreRenderMovieMeta(meta) {
        if(meta && meta != undefined) {
            return this.meta = this._processMovieMeta(meta);
        } else {
            this.meta = undefined
        }

        return this.meta
    }

    /**
     *
     * @returns {Promise.<Movies>|*}
     */
    getMovieMeta(noCache) {
        return this.meta = this.meta || ApiHttp.get(`/movies/meta${noCache ? '?noCache=' + noCache : ''}`)
                .then(
                    response => {
                        return this._processMovieMeta(response.data);
                    }, (error)=> {
                        this.meta = undefined;
                        return Promise.reject(error);
                    })
    }


    getExperiences(movie,noCache = false) {
        return this.getMovieMeta(noCache).then((meta)=>meta.experiences)
    }


    getGenres(noCache = false) {
        return this.getMovieMeta(noCache).then((meta)=>meta.genres)

    }


    getFeaturedContent(noCache = false){
        return this.getMovieMeta(noCache).then((meta)=>meta.featured_content)
    }

    getGenresBySlugs(slugs, noCache = false) {
        let genres = []
        if(slugs && slugs.length > 0) {
            this.getMovieMeta(noCache).then((meta) => {
                for(let s in slugs) {
                    for(let g in meta.genres) {
                        if(slugs[s] == meta.genres[g].name.toLowerCase()) {
                            genres.push(meta.genres[g])
                        }
                    }
                }
            })
        }

        return genres;
    }
}

export default new MovieMetaService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/movie-meta-service.js